export const enum ETipoPerguntaDescricao {
  //14ea53a4-209f-4a6f-a52e-27d40c18a63f
  'RespostaUnica' = 'Resposta Única',

  //2993f963-897a-47dc-9112-04bae817bc58
  'RespostaMultipla' = 'Múltipla Resposta',
}

export const enum ETipoPerguntaDescricaoId {
  'RespostaUnica' = '14ea53a4-209f-4a6f-a52e-27d40c18a63f',
  'RespostaMultipla' = '2993f963-897a-47dc-9112-04bae817bc58',
}
